module.exports = __webpack_public_path__ + "static/media/quickbooks_logo.64ba2428.png";